import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { Col } from 'react-bootstrap';
import renderRadioButtonField from '@/shared/components/form/RadioButton';
import renderSelectField from '@/shared/components/form/Select';

import renderFileInputField from '@/shared/components/form/FileInput';
import {
  Card, CardBody, CardTitleWrap, CardTitle,
} from '@/shared/components/Card';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
  FormHalfContainer,
} from '@/shared/components/form/FormElements';
import { Button } from '@/shared/components/Button';

const ChangedPassword = ({ formValues, setFormValues, onSubmit }) => {
  const { t } = useTranslation('common');

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          
          <Form onSubmit={onSubmit} initialValues={formValues}>
            {({ handleSubmit, form }) => (
              <FormContainer onSubmit={handleSubmit}>
                <FormHalfContainer>
                  <FormGroup>
                    <FormGroupLabel>Password</FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="passwordSet"
                        component="input"
                        type="text"
                        className="col-md-12"
                        placeholder="Enter your password"
                      />
                      
                    </FormGroupField>
                    <Button variant="primary" classname="mt-4" size="sm" type="submit">Change</Button>
                      
                  </FormGroup>
                 
                </FormHalfContainer>
              </FormContainer>
            )}
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

ChangedPassword.propTypes = {
    formValues: PropTypes.shape({
      currentPassword: PropTypes.string,
    }).isRequired,
    setFormValues: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };
  

export default ChangedPassword;
